/** @module polyfills */

/*
 * Polyfill for the new <dialog/>-element.
 * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/dialog
 * @return {Promise} Resolves once the polyfill is applied, or immediately when the polyfill is unnecessary.
 */
export function dialog() {
    return new Promise((resolve) => {
        if (window.HTMLDialogElement !== undefined) {
            resolve();
        }

        const dialogElements = document.querySelectorAll('dialog');

        if (dialogElements.length || document.querySelector('form[method="dialog"]')) {
            import(/* webpackMode: "lazy" */ 'dialog-polyfill').then(({ default: dialogPolyfill }) => {
                dialogElements.forEach((dialog) => {
                    dialogPolyfill.registerDialog(dialog);
                });

                resolve();
            });
        }
    });
}
